import { type Transition, type Variants } from 'framer-motion';

import { framerMotion } from '@pkg/primitives';

///
/// Tick

export enum TickVariant {
    Active = 'active',
}

export const tickVariants: Variants = {
    // `framer-motion` appears to not animate `z-index` correctly.
    // As a result, we have to independently `transition > z-index`
    // within the <Tick /> styling.
    [TickVariant.Active]: (active?: boolean) => ({
        scale: active ? [1, 1.4, 1] : 1,
    }),
};

export const tickTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.normal,
};

///
/// Pocket

export enum PocketVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const pocketTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.normal,
};

export const pocketVariants: Variants = {
    [PocketVariant.Hidden]: {
        opacity: 0,
        transition: {
            ...pocketTransition,
            delay: framerMotion.duration.faster,
            duration: framerMotion.duration.faster,
        },
    },
    [PocketVariant.Show]: {
        opacity: 1,
        transition: {
            ...pocketTransition,
        },
    },
};

export const pocketBackgroundVariants: Variants = {
    [PocketVariant.Hidden]: {
        scaleX: 0,
    },
    [PocketVariant.Show]: {
        scaleX: 1,
    },
};

export const pocketContentVariants: Variants = {
    [PocketVariant.Hidden]: {
        opacity: 0,
        scale: 0,
    },
    [PocketVariant.Show]: {
        opacity: 1,
        scale: 1,
    },
};

export enum PocketCountVariant {
    Update = 'update',
}

export const pocketCountTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.fast,
};

export const pocketCountVariants: Variants = {
    [PocketCountVariant.Update]: {
        scale: [1, 1.2, 1],
    },
};

///
/// Status Gradient

export enum StatusGradientVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const statusGradientVariants: Variants = {
    [StatusGradientVariant.Hidden]: {
        opacity: 0,
    },
    [StatusGradientVariant.Show]: {
        opacity: 1,
    },
};

export const statusGradientTransition: Transition = {
    ease: framerMotion.easing.cubic,
    duration: framerMotion.duration.slow,
};
